<template>
  <div>
    <b-row>
      <b-col sm="5">
        <InputText
          title="Nome do Evento"
          :disabled="disabled"
          :required="false"
          field="nome"
          :maxLength="250"
          v-model="localEvento.nomeEvento"
        />
      </b-col>
      <b-col sm="2">
        <DateTime
          title="Inicio do Evento"
          :disabled="disabled"
          :required="false"
          field="inicioEvento"
          format="DD/MM/YYYY"
          type="date"
          v-model="localEvento.dataInicioEvento"
        />
      </b-col>
      <b-col sm="2">
        <DateTime
          title="Fim do Evento"
          :disabled="disabled"
          :required="false"
          field="fimEvento"
          format="DD/MM/YYYY"
          type="date"
          v-model="localEvento.dataFimEvento"
        />
      </b-col>
      <b-col sm="2">
        <div class="div-btn">
          <Button
            v-if="rentId"
            :disabled="disabled"
            _key="btnImportAddress"
            title="Impor..Locação"
            :classIcon="'fa-solid fa-file-import'"
            type="info"
            size="small"
            :clicked="getEventLocation"
          />
        </div>
      </b-col>
    </b-row>

    <AddressValueObject
      markFormDirty="false"
      :disabled="disabled"
      :required="false"
      :showCity="false"
      :showState="false"
      v-model="addressValueObject"
    />
  </div>
</template>

<script>
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import DateTime from "@nixweb/nixloc-ui/src/component/forms/DateTime";
import InputText from "@nixweb/nixloc-ui/src/component/forms/InputText";
import AddressValueObject from "@nixweb/nixloc-ui/src/component/value-objects/Address.vue";

import { mapActions, mapMutations } from "vuex";

export default {
  name: "NfseLocalEvento",
  props: ["disabled", "rentId", "value"],
  components: {
    Button,
    InputText,
    DateTime,
    AddressValueObject,
  },
  data() {
    return {
      localEvento: {
        codigoEvento: "",
        nomeEvento: "",
        dataInicioEvento: "",
        dataFimEvento: "",
      },
      urlGetApi: "/api/v1/rental/address-rent/get-event-location",
      syncingFromParent: false,
      addressValueObject: {
        zipCode: "",
        street: "",
        number: "",
        complement: "",
        province: "",
        city: "",
        state: { id: "", content: "" },
      },
    };
  },
  methods: {
    ...mapActions("generic", ["getApi"]),
    ...mapMutations("generic", ["removeLoading"]),
    getEventLocation() {
      let params = { url: this.urlGetApi, obj: { any: this.rentId } };
      this.getApi(params).then((response) => {
        let e = response.content;
        this.localEvento.nomeEvento = e.nome;
        this.localEvento.dataInicioEvento = e.inicio;
        this.localEvento.dataFimEvento = e.fim;
        this.addressValueObject.zipCode = e.cep;
        this.addressValueObject.street = e.logradouro;
        this.addressValueObject.number = e.numero;
        this.addressValueObject.complement = e.complemento;
        this.addressValueObject.province = e.bairro;
        this.removeLoading(["btnImportAddress"]);
      });
    },
    createObj() {
      if (this.syncingFromParent) return;

      const obj = {
        codigoEvento: this.localEvento?.codigoEvento ?? null,
        nomeEvento: this.localEvento?.nomeEvento ?? "",
        dataInicioEvento: this.localEvento?.dataInicioEvento ?? null,
        dataFimEvento: this.localEvento?.dataFimEvento ?? null,
        cepEvento: this.addressValueObject?.zipCode ?? "",
        logradouroEvento: this.addressValueObject?.street ?? "",
        numeroEvento: this.addressValueObject?.number ?? "",
        complementoEvento: this.addressValueObject?.complement ?? "",
        bairroEvento: this.addressValueObject?.province ?? "",
      };

      this.$emit("input", obj);
    },
  },
  watch: {
    value: {
      deep: true,
      handler(v) {
        if (!v) return;

        this.syncingFromParent = true;

        Object.assign(this.localEvento, {
          codigoEvento: v.codigoEvento,
          nomeEvento: v.nomeEvento,
          dataInicioEvento: v.dataInicioEvento,
          dataFimEvento: v.dataFimEvento,
        });

        Object.assign(this.addressValueObject, {
          zipCode: v.cepEvento,
          street: v.logradouroEvento,
          number: v.numeroEvento,
          complement: v.complementoEvento,
          province: v.bairroEvento,
        });

        this.$nextTick(() => {
          this.syncingFromParent = false;
        });
      },
    },
    addressValueObject: {
      handler() {
        this.createObj();
      },
      deep: true,
    },
    localEvento: {
      handler() {
        this.createObj();
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.div-btn {
  margin-top: 37px;
}
</style>
